import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	link: {
		'&::after': {
			content: '""',
			display: 'block',
			position: 'absolute',
			bottom: 0,
			right: 0,
			top: 0,
			left: 0,
			zIndex: theme.zIndex.lifted,
		},
	},
	flight: {
		width: '100%',

		[getFromBreakpoint('md')]: {
			width: '50%',
		},
	},
	storyBookContainer: {
		display: 'flex',
		'&> div': {
			[getFromBreakpoint('md')]: {
				width: '45%',
			},
		},
	},
}));
